import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const searchCurrency = ({ text, pageNumber = 0 }) => {
  if (!text) return Promise.resolve({ data: { currencies: [] } }); // Prevents API call if text is empty
  return axios.get(`/currency/search/active/${text}/${pageNumber}`);
};

export const useSearchCurrency = ({ text = '', config = {} }) => {
  return useQuery({
    ...config,
    queryKey: ['searchResultsCurrency', text],
    queryFn: () => searchCurrency({ text }),
    enabled: !!text, // Only fetch when text is provided
  });
};
